export const MonthData = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro"
];

export const FrequencyData = [
  "Mensal",
  "Bimestral",
  "Trimestral",
  "Semestral",
  "Anual",
  "Bienal"
];

export const StatusData = ["Realizado", "Parcial", "Pendente"];

export const YearData = ["2022", "2023", "2024", "2025", "2026"];

export const teste = ["github", "outro"];
